import { EBuildingGatesType } from '../../../../json_query';
import { ensureSingleTagExists } from '../helpers';
import { ITagDefinition, TTag } from '../index';

const IBuildingGatesTypesTagType = 'advanced-buildingGates';

export interface IBuildingGatesTypesTag {
  type: 'advanced-buildingGates';
  value: EBuildingGatesType;
}

const isBuildingGatesTypesTag = (tag: TTag): tag is IBuildingGatesTypesTag => tag.type === IBuildingGatesTypesTagType;

export const buildingGatesTypesTagDefinition: ITagDefinition = {
  reduce: (tags, jsonQuery) => {
    const values = jsonQuery.building_gates_type && jsonQuery.building_gates_type.value;

    let nextTags = tags.filter(
      tag => tag.type !== IBuildingGatesTypesTagType || (values && values.some(value => value === tag.value)),
    );

    if (values !== undefined) {
      nextTags = values.reduce(
        (result, value: EBuildingGatesType) =>
          ensureSingleTagExists(
            result,
            (tag: TTag): tag is IBuildingGatesTypesTag => isBuildingGatesTypesTag(tag) && tag.value === value,
            previousTag => ({ type: IBuildingGatesTypesTagType, value }),
          ),
        nextTags,
      );
    }

    return nextTags;
  },
};
